<template>
  <el-image
    v-bind="$attrs"
    v-on="$listeners"
    :src="src"
    :preview-src-list="[src]"
    class="XwImg"
  >
    <template slot="error">
      <slot name="error"><div></div></slot>
    </template>
    <template slot="placeholder">
      <slot name="placeholder"></slot>
    </template>
  </el-image>
</template>
<script>
export default {
  name: "XwImg",
  props: {
    src: {
      default:""
    },
  },
  // computed:{
  //   url(){
  //     if(this.src.indexOf('http')>-1){
  //       return this.src
  //     }else{
  //       return this.src?require(this.src):""
  //     }
  //   }
  // },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
.XwImg{
  cursor: pointer; 
  height: 100%; 
  width: 100%; 
}
</style>
